var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 4.75V3.25C1.75 2.38805 2.09241 1.56139 2.7019 0.951905C3.31139 0.34241 4.13805 0 5 0C5.86195 0 6.6886 0.34241 7.2981 0.951905C7.9076 1.56139 8.25 2.38805 8.25 3.25V4.75H8.5C9.32845 4.75 10 5.42155 10 6.25V9.75C10 10.5785 9.32845 11.25 8.5 11.25H1.5C0.671575 11.25 0 10.5785 0 9.75V6.25C0 5.42155 0.671575 4.75 1.5 4.75H1.75ZM3.76256 2.01256C4.09075 1.68437 4.53585 1.5 5 1.5C5.46415 1.5 5.90925 1.68437 6.23745 2.01256C6.56565 2.34075 6.75 2.78587 6.75 3.25V4.75H3.25V3.25C3.25 2.78587 3.43437 2.34075 3.76256 2.01256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.13e33682cca5f4d36f6dc04f7c4c0939.svg";
export { ForwardRef as ReactComponent };